import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import axios from 'axios';
import { Table,  Input, Button, Modal,ModalHeader,ModalBody,ModalFooter } from 'reactstrap';
import { connect } from 'react-redux';
import { waveform } from 'ldrs'
import { lineSpinner } from 'ldrs'

lineSpinner.register()
waveform.register()

class StopList extends Component {
    static displayName = StopList.name;

    constructor(props) {
        super(props);

        this.state = {
            returnable: this.props.reduxData.userInfo,
            browser: `${browserName}${browserVersion}`,
            ip: "",
            globalLevel: "",
            permissionFlag: true,
            bearerVAR: "Bearer " + this.props.reduxData.apiKey,
            loadedData: [],
            stopFetchResolved: true,
            formatGuideOpen: false,
            uploadedFile: [],
            confirmDelete: false,
            toBeDeleted: "",
            confirmString: "",
            deleteAllConfirm: false,
            deleting: false
        }
        this.testPermission();
        
    }

    async testPermission() {
        //let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime()
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pagepk: "/StopList"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': this.state.bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            permissionFlag: data
        })
        //this.getCurrentLoadedData();
    }

    async getCurrentLoadedData() {
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('GetStoplistLoaded', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': this.state.bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            loadedData: data,
            stopFetchResolved: true
        })
    }

    componentDidMount() {
        //console.log("current loaded data: ", this.state.loadedData)
    }

    async removeStop() {
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            stoppk: this.state.toBeDeleted
        }
        const response = await fetch('DeleteStopStaging', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': this.state.bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.openConfirmPane(this.state.toBeDeleted);
        this.getCurrentLoadedData();
        
    }

    toggleGuide() {
        this.setState({
            formatGuideOpen: !this.state.formatGuideOpen
        })
    }

    toggleConfirm() {
        this.setState({
            confirmDelete: !this.state.confirmDelete
        })
    }

    handleFileChange(e) {
        if (e.target.files) {
            this.setState({
                uploadedFile: e.target.files[0]
            })
        }
    }

    async importStops() {
        this.props.updateFetchTime();
        const formData = new FormData();
        formData.append("file", this.state.uploadedFile);
        formData.append("filename", this.state.uploadedFile.name);
        if (this.state.uploadedFile.name.slice(-4) == ".csv") {
            const res = await axios.post("StopListFileUpload", formData, {
                headers: { 'Authorization': this.state.bearerVAR }
            });
            //const data = await res.data;
            this.setState({
                loadedData: res.data
            })
        }
        //this.getCurrentLoadedData()
    }

    openConfirmPane(pk) {
        if (this.state.confirmDelete) {
            this.setState({
                confirmDelete: false,
                toBeDeleted: "",
                confirmString: ""
            })
        }
        else {
            var confirmThis = "Confirm: deleting the " + this.state.loadedData.filter(remove => remove.pk == pk)[0].stopreason + " stop for " +
                this.state.loadedData.filter(remove => remove.pk == pk)[0].displayname + " " +
                this.state.loadedData.filter(remove => remove.pk == pk)[0].lastname + " (" +
                this.state.loadedData.filter(remove => remove.pk == pk)[0].pcid + ")"
                + "."
            this.setState({
                confirmDelete: true,
                confirmString: confirmThis,
                toBeDeleted: pk
            })
        }
    }

    async deleteAll() {
        this.props.updateFetchTime();
        this.setState({
            deleting: true
        })
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('DeleteAllStoplistStage', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': this.state.bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            deleting: false
        })
        this.getCurrentLoadedData();
        this.deleteAllToggle();
    }

    deleteAllToggle() {
        this.setState({
            deleteAllConfirm: !this.state.deleteAllConfirm
        })
    }

    stopTable() {
        return (<div>
            <Modal isOpen={this.state.confirmDelete}>
                <ModalBody>
                    {this.state.confirmString}<br />
                    Once deleted, this cannot be recovered without deleting everything and reuploading the file.
                </ModalBody>
                <ModalFooter>
                    <Button onClick={this.openConfirmPane.bind(this)}>No</Button>
                    <Button color="danger" onClick={this.removeStop.bind(this)}>Yes, Delete</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={this.state.deleteAllConfirm} toggle={this.deleteAllToggle.bind(this)}>
                <ModalHeader toggle={this.deleteAllToggle.bind(this)}>Delete Everything?</ModalHeader>
                {!this.state.deleting && <ModalBody>This will clear out the entire pre-import management table. A new document will have to be uploaded. Are you sure you want to do this?</ModalBody>}
                {this.state.deleting && <ModalBody><l-line-spinner size="40" stroke="3" speed="1" color="#86d3ff" /> </ModalBody>}
                <ModalFooter>
                    <Button color="danger" onClick={this.deleteAll.bind(this) }>Yes, wipe it all</Button>
                    <Button onClick={this.deleteAllToggle.bind(this)}>I change my mind</Button>
                </ModalFooter>
            </Modal>
            <h3>Loaded Stops Transported to PowerCampus</h3><p />
            <Table>
                <thead>
                    <tr>
                        <th>PCID</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Preferred Name</th>
                        <th>Stop Code</th>
                        <th>Stop Name</th>
                        <th>Comments</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.loadedData.map(item => (
                        <tr style={item.doesexist ? { background: 'red' } : {} }>
                            <td>{item.pcid}</td>
                            <td>{item.firstname}</td>
                            <td>{item.lastname}</td>
                            <td>{item.displayname}</td>
                            <td>{item.stopreason}</td>
                            <td>{item.stopname}</td>
                            <td>{item.comment}</td>
                            <td>{item.error}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>)
    }
    //<img src={'https://144.175.3.173/images/hobbes2.jpg'} alt="alt text"/>

    stopUpload() {
        return (<div>
            <Modal isOpen={this.state.formatGuideOpen} toggle={this.toggleGuide.bind(this)} size="xl">
                <ModalHeader toggle={this.toggleGuide.bind(this) }>
                    File Formatting Guide
                </ModalHeader>
                <ModalBody>
                    All files uploaded must be CSV files. If a file that is not a CSV is uploaded, the upload will fail. UnderTheHood can only process CSV files in the Stop List processing region. 
                    To save a file as a CSV in Excel, click the extension on the end of the end of the File Name box, and select the option named "CSV (Comma delimited) (*.csv)" to designate the file as a CSV.<br />
                    <img src={'https://144.175.3.173/images/StopList_Guide_IMG2.png'} alt="Select the 'xlsx' on the side of the file name, and choose CSV" />
                    <br />
                    Any CSV file uploaded will need to be structured in a particular way in order for the upload to properly process this information. <p />
                    <ul>
                        <li>The file must be only four columns wide. Any more or less, and the upload will fail.</li><br />
                        <li>The first row of the file must be a header row containing the names of the column. If the first row is a student row containing student information, that student will not be uploaded.</li><br />
                        <li>Every row must contain information in it. Any row that contains blank or null data will cause the import procedure to produce invalid data that it may not detect initially.
                            Rows below the last row with information will not be considered in the import procedure, and may be left blank. However, any text in the file outside of the specified pattern will cause it and the blank rows above it to be erroneously added to the import.</li><br />
                            <li>The rows themselves must follow this specific pattern:</li><br />
                    </ul>
                    <Table>
                        <thead>
                            <tr>
                                <th style={{ textAlign: 'center' }}>PCID</th>
                                <th style={{ textAlign: 'center' }}>STOP_REASON</th>
                                <th style={{ textAlign: 'center' }}>COMMENTS</th>
                                <th style={{ textAlign: 'center' }}>OPID</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>This is the 10-character identification code of the student. This code begins with the letter "P" and then the 9-digit ID number found attached to their record in PowerCampus.</td>
                                <td>This is the code for the stop that the given student should have applied to them. This is no more than 5 characters long, and can be found in the Stop List Reasons code table if needed.</td>
                                <td>Any comments that need to be applied to this particular stop should be written in this column</td>
                                <td>This column should contain the PowerCampus username of the person building and uploading this file</td>
                            </tr>
                        </tbody>
                    </Table>
                </ModalBody>
                <ModalFooter><Button onClick={this.toggleGuide.bind(this)}>Got it</Button></ModalFooter>
            </Modal>
            <h3>Upload Stops for Transport to PowerCampus</h3><p />
            <span><b>Please ensure your document is formatted correctly, or else the upload will fail. Please see our guide to formatting the file <span style={{ color: 'blue', cursor: 'pointer' }} onClick={this.toggleGuide.bind(this) }>here</span>.</b></span><br />
            <Input type="file" onChange={(e) => this.handleFileChange(e)} name="fileUpload" id="fileUpload" accept=".csv" />
            <Button onClick={this.importStops.bind(this) }>Upload</Button>
        </div>)
    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        let displayVar = <l-waveform size="35" stroke="3.5" speed="1" color="#86d3ff"></l-waveform>
        if (this.state.stopFetchResolved) {
            if (this.state.loadedData.length > 0) {
                displayVar = this.stopTable()
            }
            else {
                displayVar = this.stopUpload()
            }
        }
        return (<div>
            {displayVar}
        </div>)
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(StopList);